module.exports = __webpack_public_path__ + "img/foot-wx.27277997.png";